import { IonText } from "@ionic/react";
import { useSelector } from "react-redux";
import { selectDocumentCount } from "../../../store/documentList/selectors/selectDocumentCount";

export const DocumentCount = () => {
  const count = useSelector(selectDocumentCount);
  return (
    <IonText color="primary" style={{ fontWeight: 500 }}>
      {count} {count === 1 ? "resultado" : "resultados"}
    </IonText>
  );
};
